import template from './print_currency_pick_report.html';
import controller from './print_currency_pick_report.controller';
import './print_currency_pick_report.scss';

let printCurrencyPickComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printCurrencyPickComponent;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/currency_pick_report/print_currency_pick_report/print_currency_pick_report.component.js